import React, {
    ReactNode,
} from 'react';
import cn from 'classnames';

import { Button } from 'app/components/ui/BR1258/ButtonNewUI/Button';

import css from './DialogStaticMobileNewUI.module.scss';


export interface DialogProps {
    confirmText?: ReactNode,

    notifyOnly?: boolean,
    oneRowButtons?: boolean,
    buttonsReversed?: boolean,
    isProfileLayout?: boolean,

    onConfirm: () => void,
    onReject?: () => void,
    onConfirmOne?: () => void,
    children: ReactNode
}


export function DialogStaticMobileNewUI({
    onConfirm,
    onConfirmOne = undefined,
    onReject = undefined,

    confirmText = '',
    notifyOnly = false,
    oneRowButtons = false,
    buttonsReversed = false,
    isProfileLayout = false,
    children,
}: DialogProps) {
    const handleReject = notifyOnly ? onConfirm : onReject;

    const extraButtonHandler = onConfirmOne || handleReject;

    const buttonsContainerClasses = cn({
        [css.dialogButtonsContainer]: true,
        [css.oneRow]: oneRowButtons,
        [css.twoRows]: !oneRowButtons,
        [css.reversed]: buttonsReversed,
        [css.dialogButtonContainerProfile]: isProfileLayout,
    });


    return (
        <div className={`shadow-m ${css.dialogRoot}`}>
            {children}
            <div className={buttonsContainerClasses}>
                <Button onClick={extraButtonHandler}>
                    {confirmText}
                </Button>
            </div>
        </div>
    );
}
